import EditIcon from "@mui/icons-material/Edit";
import LogoutIcon from "@mui/icons-material/Logout";
import React, { useEffect, SyntheticEvent } from "react";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import { makeStyles } from "@mui/styles";
import AzureUser from "./AzureUser";
import AddUsers from "./AddUsers";
import AddContact from "./AddContact";
import IdealSupportUtilities from "./IdealSupportUtilities";
import Dealer from "./Dealer";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import axios from "axios";
import { Drawer } from "@mui/material";
import { BASE_URL } from "../services/client/rest";
import MySnackbarContentWrapper from "../MySnackbarContentWrapper";
import Snackbar from "@material-ui/core/Snackbar";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import CustomerApi from "../services/API/Customer.Api";
import "react-confirm-alert/src/react-confirm-alert.css";
import { confirmAlert } from "react-confirm-alert";

function descendingComparator(a: any, b: any, orderBy: any) {
  var x = a[orderBy];
  var y = b[orderBy];
  if (a[orderBy] == null) {
    if (orderBy == "DateLive") {
      x = "01/01/2000";
    }
    if (orderBy == "DateBuilt") {
      x = "01/01/2000";
    }
  }
  if (b[orderBy] == null) {
    if (orderBy == "DateLive") {
      y = "01/01/2000";
    }
    if (orderBy == "DateBuilt") {
      x = "01/01/2000";
    }
  }
  if (y < x) {
    return -1;
  }
  if (y > x) {
    return 1;
  }
  return 0;
}

function getComparator(order: any, orderBy: any) {
  return order === "desc"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {
  const stabilizedThis = array.map((el: any, index: any) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: any) => el[0]);
}

export default function AzureUserInfo({
  search,
  serialNumber,
  cutOffDealerStatus,
  queryType,
  handleDrawerClose,
  refetch,
}: {
  search: string;
  serialNumber: number;
  cutOffDealerStatus: boolean;
  queryType: number;
  handleDrawerClose(): void;
  refetch(): void;
}) {
  const [order, setOrder] = React.useState<string>("asc");
  const [orderBy, setOrderBy] = React.useState("Name");
  const [selected, setSelected] = React.useState([] as any);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [data, SetData] = React.useState([] as any);
  const [customerContacts, SetCustomerContacts] = React.useState([] as any);
  const [userRow, SetUserRow] = React.useState([] as any);
  const [dealerRow, SetDealerRow] = React.useState([] as any);
  const [showUser, SetShowUser] = React.useState(false);
  const [showAddUser, SetShowAddUser] = React.useState(false);
  const [showAddContact, SetShowAddContact] = React.useState(false);
  const [showDealer, SetShowDealer] = React.useState(false);
  const [dealerInfo, SetDealerInfo] = React.useState([] as any);
  const [showIdealSupportUtilitiesButton, SetIdealSupportUtilitiesButton] =
    React.useState(false);
  const [showIdealSupportUtilities, SetIdealSupportUtilities] =
    React.useState(false);
  const [openDrawer, SetOpenDrawer] = React.useState<any>(false);
  const [openSnackBar, setOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("" as string);

  const classes = useStyles();

  var bearer = "Bearer " + localStorage.getItem("token");
  const headers = {
    Authorization: bearer,
  };

  const handleOpenSnackbar = (isOpen: boolean, message: string) => {
    setOpen(isOpen);
    setSnackbarMessage(message);
  };

  const handleClose = (event?: SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  function RefreshAzureUsers() {
    GetAzureUsersInfo();
  }
  function RefreshDealerContacts() {
    GetCustomerContacts();
  }
  function CloseUserDrawer(value: number = 0) {
    SetShowUser(value == 0 ? false : true);
  }
  function CloseDealerDrawer(value: number = 0) {
    SetShowDealer(value == 0 ? false : true);
  }
  function CloseAddUserDrawer(value: number = 0) {
    SetShowAddUser(value == 0 ? false : true);
  }

  function CloseAddContactDrawer(value: number = 0) {
    SetShowAddContact(value == 0 ? false : true);
  }
  function CloseIdealUtilitiesDrawer(value: number = 0) {
    SetIdealSupportUtilities(value == 0 ? false : true);
  }

  function SaveUserChanges(rowUser: any) {
    SetShowUser(false);

    const request = {
      id: rowUser.id,
      serialNumber: rowUser.serialNumber,
      workstation: rowUser.workstation,
    };

    let url = BASE_URL + "Customer/UpdateAzureUser";

    axios
      .put(url, request, {
        headers,
      })
      .then((response) => {
        GetAzureUsersInfo();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function SaveDealerChanges(rowDealer: any) {
    SetShowDealer(false);

    const request = {
      id: rowDealer.id,
      dealerType: rowDealer.dealerType,
      name: rowDealer.name,
      serialNumber: rowDealer.serialNumber,
      dbserver: rowDealer.dbserver,
      wvdserver: rowDealer.wvdserver,
      retired: rowDealer.retired,
      companyPw: rowDealer.companyPw,
      dateBuilt: rowDealer.dateBuilt,
      dateLive: rowDealer.dateLive,
      appVersion: rowDealer.appVersion,
      systemService: rowDealer.systemService,
      connector: rowDealer.connector,
      accountNumber: rowDealer.accountNumber,
      numUsers: rowDealer.numUsers,
    };
    let url = BASE_URL + "Customer/UpdateDealer";

    axios
      .put(url, request, {
        headers,
      })
      .then((response) => {
        GetDealerInfoData();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function AddNewUsers() {
    SetShowAddUser(true);
  }
  function AddNewContact() {
    SetShowAddContact(true);
  }
  function IdealUtitlies() {
    SetIdealSupportUtilities(true);
  }

  const handleRowClick = (currentRow: any) => {
    SetUserRow(currentRow);
    SetShowUser(true);
  };

  const handleLogOff = (rowUser: any) => {
    const request = {
      id: rowUser.id,
      serialNumber: rowUser.serialNumber,
      userName: rowUser.userName,
    };

    let url = BASE_URL + "Customer/LogOffAzureUser";

    axios
      .put(url, request, {
        headers,
      })
      .then((response) => {
        handleOpenSnackbar(true, "User will be Log Off within two minutes.");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDealerClick = (currentRow: any) => {
    SetDealerRow(currentRow);
    SetShowDealer(true);
  };
  const headCells = [
    {
      id: "username",
      numeric: false,
      disablePadding: false,
      label: "Username",
    },
    {
      id: "password",
      numeric: false,
      disablePadding: false,
      label: "Password",
    },
    {
      id: "workstation",
      numeric: false,
      disablePadding: false,
      label: "Workstation",
    },
    {
      id: "isActive",
      numeric: false,
      disablePadding: false,
      label: "IsActive",
    },
    {
      id: "activeServer",
      numeric: false,
      disablePadding: false,
      label: "ActiveServer",
    },
    { id: "logoff", numeric: false, disablePadding: false, label: "Log Off" },
    { id: "edit", numeric: false, disablePadding: false, label: "" },
  ];

  function EnhancedTableHead(props: any) {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property: any) => (event: any) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              style={{ backgroundColor: "#F2F3F4" }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  function TablePaginationActions(props: any) {
    const theme: any = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event: any) => {
      setPage(0);
    };

    const handleBackButtonClick = (event: any) => {
      setPage(page - 1);
    };

    const handleNextButtonClick = (event: any) => {
      setPage(page + 1);
    };

    const handleLastPageButtonClick = (event: any) => {
      setPage(Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRightIcon />
          ) : (
            <KeyboardArrowLeftIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeftIcon />
          ) : (
            <KeyboardArrowRightIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };

  useEffect(() => {
    if (queryType == 0) {
      SetIdealSupportUtilitiesButton(true);
    }
    GetDealerInfoData();
    GetAzureUsersInfo();
    GetCustomerContacts();
    SetOpenDrawer(true);
  }, [queryType, serialNumber]);

  function GetAzureUsersInfo() {
    let url = BASE_URL + "Customer/AzureUsers/" + serialNumber;

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => SetData(data.data))
      .catch
      //error => alert('Error: ' + error)
      ();
  }

  function GetDealerInfoData() {
    let url = BASE_URL + "Customer/Dealer/" + serialNumber;

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => SetDealerInfo(data.data))
      .catch
      //error => alert('Error: ' + error)
      ();
  }

  function GetCustomerContacts() {
    let url = BASE_URL + "Customer/CustomerContacts/" + serialNumber;
    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // debugger;
        SetCustomerContacts(data.data);
        //console.log(customerContacts);
      })
      .catch
      //error => alert('Error: ' + error)
      ();
  }

  const CutOffDealerHandler = async (serialNumber: Number) => {
    try {
      //! Drawer Close
      SetOpenDrawer(false);
      //! Confirm Dialogue.
      confirmAlert({
        title: cutOffDealerStatus
          ? "Confirm to Enable Dealer"
          : "Confirm to Cut Off Dealer",
        message: cutOffDealerStatus
          ? "Are you sure to Enable Dealer?"
          : "Are you sure to Cut Of Dealer?",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              await CustomerApi.cutOffDealer(serialNumber);
              //! Success Toaster
              cutOffDealerStatus
                ? handleOpenSnackbar(true, "Dealer Enable Successfully")
                : handleOpenSnackbar(true, "Dealer Cut Off Successfully");
              //! Refetch customers
              refetch();
            },
          },
          {
            label: "No",
            onClick: () => {
              SetOpenDrawer(true);
            },
          },
        ],
      });
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: any) => {};

  const handleClick = (event: any, name: any) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected: any = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event: any) => {
    setDense(event.target.checked);
  };

  const isSelected = (name: any) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - GetData().length) : 0;

  function GetData() {
    return data.filter(filterRow);
  }

  function filterRow(element: any, index: any, array: any) {
    if (data.length > 0) {
      var obj1 = data[0];
      var keys = Object.keys(obj1);
      let i = 0;
      for (i = 0; i < keys.length; i++) {
        let cellValue = String(element[keys[i]]);
        if (cellValue.toLowerCase().includes(search.toLowerCase())) {
          return true;
        }
      }
    }
    return false;
  }

  return (
    <Box>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={openSnackBar}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <MySnackbarContentWrapper
          onClose={handleClose}
          variant="success"
          message={snackbarMessage}
        />
      </Snackbar>

      <Drawer
        PaperProps={{ style: { width: "auto" } }}
        anchor="right"
        open={openDrawer}
        onClose={() => {
          handleDrawerClose();
          SetOpenDrawer(false);
        }}
        variant={"temporary"}
      >
        <Box sx={{ width: "auto", display: "table" }}>
          <Paper
            sx={{
              width: "auto",
              mb: 2,
              margin: "10px 10px",
              border: "1px solid #E5E7E9",
            }}
          >
            <Box style={{ display: "table" }}>
              <h3>Azure User Information</h3>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>SerialNumber</TableCell>
                    <TableCell>DBServer</TableCell>
                    <TableCell>WVDServer</TableCell>
                    <TableCell>AccountNumber</TableCell>
                    <TableCell>CompanyPassword</TableCell>
                    {showIdealSupportUtilitiesButton ? (
                      <TableCell></TableCell>
                    ) : null}
                  </TableRow>
                </TableHead>
                {dealerInfo.map((row: any, index: any) => {
                  return (
                    <TableRow hover role="checkbox">
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.serialNumber}</TableCell>
                      <TableCell>{row.dbserver}</TableCell>
                      <TableCell>{row.wvdserver}</TableCell>
                      <TableCell>{row.accountNumber}</TableCell>
                      <TableCell>{row.companyPw}</TableCell>
                      {showIdealSupportUtilitiesButton ? (
                        <TableCell
                          style={{
                            color: "blue",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                          onClick={(event) => handleDealerClick(row)}
                        >
                          <EditIcon
                            style={{ fontSize: "small", color: "gray" }}
                          ></EditIcon>
                        </TableCell>
                      ) : null}
                    </TableRow>
                  );
                })}
              </Table>
            </Box>
          </Paper>
          <Dealer
            open={showDealer}
            rowDealer={dealerRow}
            SaveDealerChanges={SaveDealerChanges}
            onClose={CloseDealerDrawer}
          />
          <Paper
            sx={{
              width: "auto",
              mb: 2,
              margin: "10px 10px",
              border: "1px solid #E5E7E9",
            }}
          >
            <Box style={{ display: "table" }}>
              <h3>Additional Contacts</h3>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Phone</TableCell>
                    <TableCell>SerialNumber</TableCell>
                  </TableRow>
                </TableHead>
                {customerContacts.map((row: any, index: any) => {
                  return (
                    <TableRow hover role="checkbox">
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>{row.phone}</TableCell>
                      <TableCell>{row.customerSerialNumber}</TableCell>
                    </TableRow>
                  );
                })}
              </Table>
            </Box>
          </Paper>
          <Paper
            sx={{
              width: "auto",
              mb: 2,
              margin: "10px 10px",
              border: "1px solid #E5E7E9",
            }}
          >
            <TableContainer>
              <Table
                sx={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
                size={dense ? "small" : "medium"}
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={GetData().length}
                />
                <TableBody>
                  {stableSort(GetData(), getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row: any, index: any) => {
                      return (
                        <TableRow hover role="checkbox" key={row.id}>
                          <TableCell>{row.userName}</TableCell>
                          <TableCell>{row.password}</TableCell>
                          <TableCell>{row.workstation}</TableCell>
                          <TableCell>{row.isActive}</TableCell>
                          <TableCell>{row.activeServer}</TableCell>
                          <TableCell
                            style={{
                              color: "blue",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            onClick={(event) => handleLogOff(row)}
                          >
                            <LogoutIcon
                              style={{ fontSize: "small", color: "gray" }}
                            ></LogoutIcon>
                          </TableCell>
                          <TableCell
                            style={{
                              color: "blue",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            onClick={(event) => handleRowClick(row)}
                          >
                            <EditIcon
                              style={{ fontSize: "small", color: "gray" }}
                            ></EditIcon>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: (dense ? 33 : 53) * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 20, 25, 50, 100]}
              component="div"
              count={GetData().length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Paper>
          <AzureUser
            open={showUser}
            rowUser={userRow}
            SaveUserChanges={SaveUserChanges}
            onClose={CloseUserDrawer}
          />
          <div style={{ position: "fixed", top: "10px", right: "5px" }}>
            <table>
              <tr>
                {cutOffDealerStatus ? (
                  <td>
                    <Fab
                      className={classes.enableDealer}
                      variant="extended"
                      size="small"
                      onClick={() => CutOffDealerHandler(serialNumber)}
                      title="Cut Off Dealer"
                    >
                      {<AddCircleOutlineOutlinedIcon />} Enable Dealer &nbsp;
                    </Fab>
                  </td>
                ) : (
                  <td>
                    <Fab
                      className={classes.cutOff}
                      variant="extended"
                      size="small"
                      onClick={() => CutOffDealerHandler(serialNumber)}
                      title="Cut Off Dealer"
                    >
                      {<RemoveCircleOutlineOutlinedIcon />} Cut Off Dealer
                      &nbsp;
                    </Fab>
                  </td>
                )}

                <td>
                  <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    onClick={() => AddNewUsers()}
                    title="Add Users"
                  >
                    {<AddIcon></AddIcon>}Add User &nbsp;
                  </Fab>
                  <AddUsers
                    open={showAddUser}
                    onClose={CloseAddUserDrawer}
                    serialNumber={serialNumber}
                    RefreshAzureUsers={RefreshAzureUsers}
                  />
                </td>
                <td>
                  <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    onClick={() => AddNewContact()}
                    title="Add Contact"
                  >
                    {<AddIcon></AddIcon>}Add Contact &nbsp;
                  </Fab>
                  <AddContact
                    open={showAddContact}
                    onClose={CloseAddContactDrawer}
                    serialNumber={serialNumber}
                    RefreshDealerContacts={RefreshDealerContacts}
                  />
                </td>
                {showIdealSupportUtilitiesButton ? (
                  <td>
                    <Fab
                      variant="extended"
                      size="small"
                      color="primary"
                      onClick={() => IdealUtitlies()}
                      title="Ideal Support Utilities"
                    >
                      {<AddIcon></AddIcon>}Ideal Support Utilities &nbsp;
                    </Fab>
                    <IdealSupportUtilities
                      open={showIdealSupportUtilities}
                      onClose={CloseIdealUtilitiesDrawer}
                      serialNumber={serialNumber}
                    />
                  </td>
                ) : null}
              </tr>
            </table>
          </div>
        </Box>
      </Drawer>
    </Box>
  );
}

//---------- Styles ----------//
const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
  },

  alert1: {
    backgroundColor: "#E74C3C",
    color: "white",
  },

  hideCell: {
    display: "none !important",
  },

  cutOff: {
    background: "tomato !important",
    color: "white !important",
  },

  enableDealer: {
    background: "#87CEEB !important",
    color: "white !important",
  },
}));
